module.exports = __webpack_public_path__ + "static/media/weiya.df9ea359.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/weiya.webp
// module id = 867
// module chunks = 0